export const ComprehensiveUtils = {
    
  getScoreNoCredit : (obj)=>{
    if (obj.crPoints == 127)
      return 'not scored';
    if (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crAnswered == 0)
      return 'Not started';
    else if (obj.crPoints == -2)
      return 'Not Scored';
    else if (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crAnswered < obj.questionCount || obj.crPoints == -1)
      return 'Incomplete';
    else if (!obj.scoreOption)
    {
      let score = 0;
      if (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crMaxPoints > 0)
        if (obj.isSchoology)
          score += ((obj.correct + obj.crPoints) * 100.0 / (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crMaxPoints));
        else
          score += Math.round((obj.correct + obj.crPoints) * 100 / (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crMaxPoints));
      return (score + '%');
    }
    else
      return (obj.correct + obj.crPoints);
  },
    
  getScoreWithRetryAsHalfCredit : (obj)=>{
    if (obj.crPoints == 127)
      return 'not scored';
    if (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crAnswered == 0)
      return 'Not started';
    else if (obj.crPoints == -2)
      return 'Not Scored';
    else if (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crAnswered < obj.questionCount || obj.crPoints == -1)
      return 'Incomplete';
    else if (!obj.scoreOption)
    {
      let score = 0;
      if (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crMaxPoints > 0)
        if (obj.isSchoology)
          score += ((obj.correct + (obj.correctOnRetry / 2.0) + obj.crPoints) * 100.0 / (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crMaxPoints));    
        else
          score += Math.round((obj.correct + (obj.correctOnRetry / 2.0) + obj.crPoints) * 100.0 / (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crMaxPoints));
      return (score + '%');
    }
    else
      return ((obj.correct + (obj.correctOnRetry / 2.0) + obj.crPoints));
  }, 
    
  getScoreWithRetryFullCredit:(obj)=>{
    if (obj.crPoints == 127)
      return 'not scored';
    if (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crAnswered == 0)
      return 'Not started';
    else if (obj.crPoints == -2)
      return 'Not Scored';
    else if (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crAnswered < obj.questionCount || obj.crPoints == -1)
      return 'Incomplete';
    else if (!obj.scoreOption)
    {
      let score = 0;
      if (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crMaxPoints > 0)
        if (obj.isSchoology)
          score += ((obj.correct + obj.correctOnRetry + obj.crPoints) * 100.0 / (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crMaxPoints));
        else
          score += Math.round((obj.correct + obj.correctOnRetry + obj.crPoints) * 100.0 / (obj.correct + obj.inCorrect + obj.correctOnRetry + obj.crMaxPoints));
      return (score + '%');
    }
    else
      return (obj.correct + obj.correctOnRetry + obj.crPoints);
  },
    
  getStandardPoints : (standard,retries)=>{
    switch (retries)
    {
    default:
    case 1:
      return (standard.crPoints + standard.correct);
    
    case 2:
      return (standard.crPoints + standard.correct + standard.correctOnRetry / 2.0);
    
    case 3:
      return (standard.crPoints + standard.correct + standard.correctOnRetry);
    }
  },
    
  getStandardPercent : (standard,retries)=>{
    if (standard.crPoints == -127)
      return 0;
    // Score only if answered
    let count = standard.correct + standard.inCorrect + standard.correctOnRetry;
    if (count + standard.crAnswered > 0)
    {
      count += standard.crMaxPoints;
      if (count > 0)
      {
        switch (retries)
        {
        default:
        case 1:
          return Math.round((standard.correct + standard.crPoints) * 100.0 / count) +'%';
    
        case 2:
          return Math.round(((standard.correct + standard.correctOnRetry / 2.0 + standard.crPoints) * 100.0) / count)+'%';
    
        case 3:
          return Math.round(((standard.correct + standard.correctOnRetry + standard.crPoints) * 100.0) / count)+'%';
        }
      }
    }
    return 0 +'%';
  },
    
  getStandardScore : (standardScores,scoreOption,retries)=>{
    let standardScore=0;
    let standardScoreList = [];
    standardScores.map((standard)=>{
      if(scoreOption)
        standardScore = ComprehensiveUtils.getStandardPoints(standard,retries);
      else
        standardScore = ComprehensiveUtils.getStandardPercent(standard,retries);
      standardScoreList.push(standardScore);
    });
    return standardScoreList;
  }
};